import BaseResource from './index'

export default class OnProductionResource extends BaseResource {
    static endpoint = '/oasis/restv3/onProductions'
    static cacheMaxAge = 18000
}
